import { c as _c } from "react/compiler-runtime";
import { object, string, useForm } from "@website/form/hook/form.hooks";
import { useJwtToken } from "@website/hooks/auth-manager";
import { getChannel } from "@website/utils/channel/get-channel";
import { useSendToTelesales } from "@website/widget/telesales/telesales-form/queries";
import { TelesalesFormPropertiesType, TelesalesFromDataType } from "@website/widget/telesales/telesales-form/types";
import { useState } from "react";
export const useTelesales = t0 => {
  const $ = _c(23);
  const {
    onClose,
    requestData,
    storageKey,
    onSuccess,
    onSubmitSuccess,
    reasons
  } = t0;
  const {
    mutateAsync,
    isPending
  } = useSendToTelesales();
  const {
    phoneNumber,
    name
  } = useJwtToken();
  const [isPhoneStep, setIsPhoneStep] = useState(true);
  let t1;
  if ($[0] !== phoneNumber) {
    t1 = phoneNumber?.replace?.("+98", "0") || "";
    $[0] = phoneNumber;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = {
      freeTransferMobileNumber: t1
    };
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = object({
      freeTransferMobileNumber: string().required().mobile()
    });
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t2) {
    t4 = {
      mode: "onBlur",
      defaultValues: t2,
      validations: t3
    };
    $[5] = t2;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const {
    control,
    handleSubmit
  } = useForm(t4);
  let t5;
  if ($[7] !== isPhoneStep || $[8] !== mutateAsync || $[9] !== name || $[10] !== onClose || $[11] !== onSubmitSuccess || $[12] !== onSuccess || $[13] !== reasons || $[14] !== requestData || $[15] !== storageKey) {
    t5 = async data => {
      if (isPhoneStep) {
        setIsPhoneStep(false);
        return;
      }
      onClose();
      const reasonSelected = [];
      for (const property in data) {
        if (data[property] && property !== "reason" && property !== "freeTransferMobileNumber") {
          reasonSelected.push(reasons[property]);
        }
      }
      localStorage.setItem(storageKey, Date.now()?.toString());
      await mutateAsync({
        channel: getChannel(),
        phone: data?.freeTransferMobileNumber,
        description: data?.reason || "",
        fullname: name || "",
        reasons: reasonSelected,
        ...requestData
      });
      onSuccess?.();
      onSubmitSuccess();
    };
    $[7] = isPhoneStep;
    $[8] = mutateAsync;
    $[9] = name;
    $[10] = onClose;
    $[11] = onSubmitSuccess;
    $[12] = onSuccess;
    $[13] = reasons;
    $[14] = requestData;
    $[15] = storageKey;
    $[16] = t5;
  } else {
    t5 = $[16];
  }
  const handleSetEvent = t5;
  let t6;
  if ($[17] !== control || $[18] !== handleSetEvent || $[19] !== handleSubmit || $[20] !== isPending || $[21] !== isPhoneStep) {
    t6 = {
      handleSetEvent,
      isPhoneStep,
      control,
      isPending,
      handleSubmit
    };
    $[17] = control;
    $[18] = handleSetEvent;
    $[19] = handleSubmit;
    $[20] = isPending;
    $[21] = isPhoneStep;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};